export const STORE_PRODUCTS = Object.freeze([
  {
    id: 'cos.starter.supporter', type: 'non-consumable', category: 'starter', priceTHB: 149,
    title: 'ชุดผู้พิทักษ์เริ่มต้น', badge: 'คุ้มสุด',
    description: 'ธีมเกาะรุ่งอรุณ + กรอบโปรไฟล์ผู้ก่อตั้ง + Crystal 600',
    grant: { crystals: 600, cosmetics: ['island_dawn', 'frame_founder'] }
  },
  {
    id: 'cos.builder.license', type: 'non-consumable', category: 'convenience', priceTHB: 149,
    title: 'Builder License', badge: 'ถาวร',
    description: 'เพิ่มช่างก่อสร้าง 1 คน ไม่เพิ่มพลังในการรบ',
    grant: { entitlements: ['builder_slot_3'] }
  },
  {
    id: 'cos.layout.deck', type: 'non-consumable', category: 'convenience', priceTHB: 79,
    title: 'ชุดแปลนเกาะ', badge: 'ถาวร',
    description: 'บันทึก layout ฐานเพิ่ม 3 ช่อง สลับได้โดยไม่เสียทรัพยากร',
    grant: { entitlements: ['layout_slots_3'] }
  },
  {
    id: 'cos.season.skywarden', type: 'non-renewing-subscription', category: 'season', priceTHB: 179,
    title: 'Sky Warden Season', badge: '30 วัน',
    description: 'รับรอยเท้าออโรรา + กรอบ Cloud Lion ทันที และสิทธิ์ Season 30 วัน ไม่มีค่าสเตตัส',
    grant: { entitlements: ['season_cosmetic_track'], cosmetics: ['trail_aurora', 'frame_cloudlion'], durationDays: 30 }
  },
  { id: 'cos.crystal.300', type: 'consumable', category: 'currency', priceTHB: 35, title: 'Crystal 300', description: 'ใช้ซื้อของตกแต่งเท่านั้น', grant: { crystals: 300 } },
  { id: 'cos.crystal.950', type: 'consumable', category: 'currency', priceTHB: 99, title: 'Crystal 950', badge: '+12%', description: 'ใช้ซื้อของตกแต่งเท่านั้น', grant: { crystals: 950 } },
  { id: 'cos.crystal.2100', type: 'consumable', category: 'currency', priceTHB: 199, title: 'Crystal 2,100', badge: '+23%', description: 'ใช้ซื้อของตกแต่งเท่านั้น', grant: { crystals: 2100 } },
  { id: 'cos.crystal.4600', type: 'consumable', category: 'currency', priceTHB: 399, title: 'Crystal 4,600', badge: '+35%', description: 'ใช้ซื้อของตกแต่งเท่านั้น', grant: { crystals: 4600 } }
]);

export const COSMETIC_CATALOG = Object.freeze([
  { id: 'island_twilight', title: 'เกาะแสงสนธยา', description: 'เปลี่ยนบรรยากาศเมืองเป็นยามค่ำสีม่วง', cost: 700, icon: '🌌' },
  { id: 'ui_gilded', title: 'ขอบ UI ทองเมฆา', description: 'ตกแต่งกรอบ HUD และโปรไฟล์ ไม่มีค่าสเตตัส', cost: 450, icon: '✨' },
  { id: 'trail_aurora', title: 'รอยเท้าออโรรา', description: 'เอฟเฟกต์เคลื่อนที่ของกองทัพ ไม่มีค่าสเตตัส', cost: 550, icon: '🌈' },
  { id: 'frame_cloudlion', title: 'กรอบ Cloud Lion', description: 'กรอบโปรไฟล์สะสมประจำฤดูกาล', cost: 300, icon: '🦁' }
]);

export function monetizationDefaults() {
  return { crystals: 0, entitlements: [], cosmetics: [], purchaseReceipts: [], seasonExpiresAt: 0 };
}

export function hydrateMonetization(value = {}) {
  const defaults = monetizationDefaults();
  return {
    ...defaults, ...value,
    crystals: Math.max(0, Math.floor(Number(value.crystals) || 0)),
    entitlements: [...new Set(value.entitlements || [])],
    cosmetics: [...new Set(value.cosmetics || [])],
    purchaseReceipts: [...new Set(value.purchaseReceipts || [])].slice(-100)
  };
}

export function applyVerifiedPurchase(state, verification) {
  const product = STORE_PRODUCTS.find(item => item.id === verification?.productId);
  if (!product || !verification?.verified || !verification.transactionId) return { ok: false, reason: 'รายการซื้อยังไม่ผ่านการตรวจสอบจากร้านค้า' };
  state.monetization = hydrateMonetization(state.monetization);
  if (state.monetization.purchaseReceipts.includes(verification.transactionId)) return { ok: true, duplicate: true, product };
  if (product.type !== 'consumable' && state.monetization.entitlements.includes(product.id)) return { ok: true, duplicate: true, product };
  const grant = product.grant;
  state.monetization.crystals += grant.crystals || 0;
  state.monetization.cosmetics.push(...(grant.cosmetics || []));
  state.monetization.entitlements.push(...(grant.entitlements || []));
  if (product.type !== 'consumable') state.monetization.entitlements.push(product.id);
  if (grant.durationDays) state.monetization.seasonExpiresAt = Math.max(Date.now(), state.monetization.seasonExpiresAt || 0) + grant.durationDays * 86400000;
  state.monetization.cosmetics = [...new Set(state.monetization.cosmetics)];
  state.monetization.entitlements = [...new Set(state.monetization.entitlements)];
  state.monetization.purchaseReceipts.push(verification.transactionId);
  return { ok: true, product, grant };
}

export function purchaseCosmetic(state, cosmeticId) {
  const item = COSMETIC_CATALOG.find(entry => entry.id === cosmeticId);
  if (!item) return { ok: false, reason: 'ไม่พบของตกแต่งนี้' };
  state.monetization = hydrateMonetization(state.monetization);
  if (state.monetization.cosmetics.includes(item.id)) return { ok: false, reason: 'มีของตกแต่งนี้แล้ว' };
  if (state.monetization.crystals < item.cost) return { ok: false, reason: 'Cosmetic Crystal ไม่พอ' };
  state.monetization.crystals -= item.cost;
  state.monetization.cosmetics.push(item.id);
  return { ok: true, item };
}

export class BillingService {
  constructor({ verifyEndpoint = '/api/billing/verify' } = {}) { this.verifyEndpoint = verifyEndpoint; }
  get available() { return Boolean(globalThis.ClashBilling?.purchase); }
  async purchase(productId) {
    if (!this.available) throw new Error('ร้านเงินจริงยังไม่เชื่อมกับ StoreKit หรือ Google Play Billing');
    const receipt = await globalThis.ClashBilling.purchase(productId);
    const response = await fetch(this.verifyEndpoint, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ productId, receipt }) });
    if (!response.ok) throw new Error('ตรวจสอบใบเสร็จกับเซิร์ฟเวอร์ไม่สำเร็จ');
    return response.json();
  }
  async restore() {
    if (!globalThis.ClashBilling?.restore) throw new Error('อุปกรณ์นี้ยังไม่รองรับการคืนค่ารายการซื้อ');
    return globalThis.ClashBilling.restore();
  }
}
